const SOURCE_WORKFLOW_LABELS: Record<string, string> = {
  'bulk-dispose-pending-bin-queue': 'Pending Bin Queue',
  'bulk-dispose-from-stock': 'From Stock',
  'bulk-dispose-complete': 'Bulk Dispose',
  'bulk-inventory-return-to-shelf-complete': 'Scanner App: Return to Shelf',
};

const toTitleCase = (value: string): string =>
  value
    .split(/\s+/g)
    .filter((segment) => segment.length > 0)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase())
    .join(' ');

export const resolveWorkflowSourceLabel = ({
  sourceWorkflow,
  isScannerApp,
  isKiosk,
}: {
  sourceWorkflow?: string | null;
  isScannerApp?: boolean;
  isKiosk?: boolean;
}): string => {
  if (isScannerApp) {
    return isKiosk ? 'Scanner App: Kiosk' : 'Scanner App: Issue Out';
  }
  return formatSourceWorkflowLabel(sourceWorkflow);
};

export const formatSourceWorkflowLabel = (sourceWorkflow?: string | null): string => {
  if (typeof sourceWorkflow !== 'string') {
    return '—';
  }

  const trimmed = sourceWorkflow.trim();
  if (!trimmed) {
    return '—';
  }

  const mapped = SOURCE_WORKFLOW_LABELS[trimmed.toLowerCase()];
  if (mapped) {
    return mapped;
  }

  return toTitleCase(trimmed.replace(/[-_]+/g, ' '));
};

export const shouldHideTransactionTypeForSource = (sourceWorkflow?: string | null): boolean => {
  if (typeof sourceWorkflow !== 'string') {
    return false;
  }

  const normalized = sourceWorkflow.trim().toLowerCase();
  return (
    normalized === 'bulk-inventory-bin-complete' ||
    normalized === 'bulk-inventory-return-to-shelf-complete'
  );
};

const normalizeChipValue = (value: string | null | undefined): string =>
  typeof value === 'string' ? value.trim().toUpperCase() : '';

export const shouldHideDocumentTypeChip = (input: {
  transactionType?: string | null;
  documentType?: string | null;
  handReceiptTypes?: readonly ('PHR' | 'THR')[];
}): boolean => {
  const transactionType = normalizeChipValue(input.transactionType);
  const documentType = normalizeChipValue(input.documentType);
  if (transactionType === 'DA4949' && documentType === '4949') {
    return true;
  }

  if (transactionType === 'TRANSFER' && documentType === 'TRANSFER') {
    return true;
  }

  if (transactionType === 'SHIPMENT' && documentType === 'SHIPMENT') {
    return true;
  }

  const hasReceiptTypeChips =
    Array.isArray(input.handReceiptTypes) && input.handReceiptTypes.length > 0;
  if (documentType === 'HAND RECEIPT' && hasReceiptTypeChips) {
    return true;
  }

  return false;
};
